import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NJDocData, NJDocDefTemplate, DOData, componentVM } from '../DOData';
import { ChangeDetectorRef } from '@angular/core';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { forEach } from '@angular/router/src/utils/collection';
import { faCaretUp, faCaretDown, IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'cy-grid-internal',
    templateUrl: './grid-internal.component.html',
    styleUrls: ['./grid-internal.component.css']
})
export class GridInternalComponent implements OnInit {
    private maxRow = -1;

    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() public loaderKey: string;

    @Input() lstDocData: Array<NJDocData> = new Array<NJDocData>();
    @Input() inChildDocDefTemplate: Array<NJDocDefTemplate>

    @Input() customParameters: any;
    @Input() allowDoubleClick: boolean;

    @Input() isValid: boolean = true;
    @Input() isHideTitles: boolean = false;
    @Input() isEnabled: boolean = true;

    @Input() GridID: any
    @Input() isPopUpYesNo: string;
    @Input() isPopUpSelected: boolean = false;

    @Output() editItem: EventEmitter<Array<DOData>> =
        new EventEmitter<Array<DOData>>();

    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    @Output() tabEvent: EventEmitter<componentVM> =
        new EventEmitter<componentVM>();

    @Output() clickLink: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    buttonClickPending: number = 0;

    private sectionClass: string;

    gridStyle: object;
    tableStyle: object = {};
    height: string;

    ButonIcon: IconDefinition = null;
    private sortDirection: Array<number>;
    curSortCol: number = -1;

    curRow: Array<DOData>;

    selectedRow: number = -1;
    getColsAll: Array<DOData>;
    // this creates an array of all the data with the template info (cols info)
    _getCols: Array<DOData>;
    get getCols(): Array<DOData> {
        return this._getCols;
    }
    set getCols(value: Array<DOData>) {
        this._getCols = value;
    }
    _getRows: number[];
    get getRows(): number[] {
        return this._getRows;
    }
    set getRows(value: number[]) {
        this._getRows = value;
    }
    _lstChildDocDefTemplate: Array<NJDocDefTemplate> = new Array<NJDocDefTemplate>();
    get lstChildDocDefTemplate(): Array<NJDocDefTemplate> {
        return this._lstChildDocDefTemplate;
    }
    set lstChildDocDefTemplate(value: Array<NJDocDefTemplate>) {
        this._lstChildDocDefTemplate = value;
    }

    constructor(private cdr: ChangeDetectorRef, private data: DocDefPrimLibService) { }

    ngOnInit() {
        if (this.customParameters['isPopUpSelected'] == 'True')
            this.isPopUpSelected = true;
        if (this.customParameters['scrollHeight']) {
            this.height = this.customParameters['scrollHeight'];
            this.gridStyle = { overflow: 'auto', height: this.height + 'px' }
        }
        if (this.customParameters['tableStyle']) {
            let styles = this.data.replaceAll(this.customParameters['tableStyle'], "'", '"');
            this.tableStyle= JSON.parse(styles);
        }
    }
    getRowStyle(row): object {
        if (row == this.selectedRow && this.isPopUpSelected) {
            return { "border-color": "transparent", "background-color": "lightsteelblue" };
        } else {
            return { "border-color": "transparent" };
        }
    }
    getValidation(): string {
        if (this.isValid) {
            return "table-responsive"
        } else {
            return "bg-danger table-responsive";
        }
    }
    getValidationStyle(): object {
        if (this.isValid)
            return null
        else
            return { 'background-color': 'lightpink' };
    }
    ngOnChanges(): void {
        if (typeof (this.customParameters['isHideTitles']) != 'undefined')
            if (this.customParameters['isHideTitles'] == 'No') {
                this.isHideTitles = false;
            }
        // templates changed
        this.lstChildDocDefTemplate = [];
        for (var i: number = 0; i < this.inChildDocDefTemplate.length; i++) {
            if ((this.inChildDocDefTemplate[i].dictCustomParameters['isGridColumn'] == "True"
                || this.inChildDocDefTemplate[i].dictCustomParameters['isGridColumn'] == null) &&
                (this.inChildDocDefTemplate[i].dictCustomParameters['isPopUp'] == this.isPopUpYesNo
                    || this.inChildDocDefTemplate[i].dictCustomParameters['isPopUp'] == null))
                this.lstChildDocDefTemplate.push(this.inChildDocDefTemplate[i]);

        }
        this.sortDirection = new Array<number>();
        for (var i: number = 0; i < this.inChildDocDefTemplate.length; i++) {
            this.sortDirection.push(0);
        }
        //calc rows because data changed
        this.calc_rows();
    }
    public getGridVM_byRow(row: number): Array<DOData> {
        this.curRow = this.performFilterRow(row);
        return this.curRow;
    }

    performFilterRow(row: number): Array<DOData> {
        return this.getCols.filter((d: DOData) => {
            return (d.njDocData.docDefDataRowID == row && d.njDocDefTemplate.docDefTemplateID == d.njDocData.docDefTemplateID)
        })
    }
    /* All Data */
    public getGridVM_byRowAll(row: number): Array<DOData> {
        this.curRow = this.performFilterRowAll(row);
        return this.curRow;
    }
    performFilterRowAll(row: number): Array<DOData> {
        return this.getColsAll.filter((d: DOData) => {
            return (d.njDocData.docDefDataRowID == row && d.njDocDefTemplate.docDefTemplateID == d.njDocData.docDefTemplateID)
        })
    }
    /* End All Data */
    getColSpan(item: DOData): number {
        if (item.customParameters['Colspan'] == null) {
            return 1;
        } else {
            return +item.customParameters['Colspan'];
        }
    }
    calc_rows() {
        this.sort_rows(0)
        this.calc_cols();
        this.calc_colsAll();
    }
    thClick(col: NJDocDefTemplate) {
        let i: number = 0;
        for (let item of this.lstChildDocDefTemplate) {
            if (item.docDefTemplateID == col.docDefTemplateID)
                break;
            i++;
        }
       
        this.sort_rows(i);
    }
    sort_rows(col: number) {
        this.curSortCol = col;
        // change direction of sort
        if (this.sortDirection[col] == 0) {
            this.sortDirection[col] = 1         
        } else {
            this.sortDirection[col] = this.sortDirection[col] * -1;
        }
        if (this.sortDirection[col] == 1) {
            this.ButonIcon = faCaretUp;
        } else {
            this.ButonIcon = faCaretDown;
        }
        let type: string = '';
        if (this.lstChildDocDefTemplate[col].dictCustomParameters['type'] != null)
            if (this.lstChildDocDefTemplate[col].dictCustomParameters['type'] == 'number')
                type = this.lstChildDocDefTemplate[col].dictCustomParameters['type'];
        class index { irow: number; sortIdx: string; sortdir:number; type: string='' };
        let ret: Array<index> = new Array<index>(); 
        //get unique rows and the field to be sorted on (default to first field)
        for (let i: number = 0; i < this.lstDocData.length; i++) {
            if (ret.map(function (e) { return e.irow }).indexOf(this.lstDocData[i].docDefDataRowID) === -1) {
                ret.push({ irow: this.lstDocData[i].docDefDataRowID, sortIdx: this.lstDocData[i + col].dataValue, sortdir:this.sortDirection[col], type: type})
            }
        }

        //sort rows by field
        ret.sort(function (a, b) {
            if (a.type == 'number') {
                if (+a.sortIdx < +b.sortIdx) {
                    return -1 * a.sortdir
                }
                if (+a.sortIdx > +b.sortIdx) {
                    return 1 * a.sortdir
                }
            } else if (a.type == 'date') {
                if (new Date(a.sortIdx) < new Date(b.sortIdx)) {
                    return -1 * a.sortdir
                }
                if (new Date(a.sortIdx) > new Date(b.sortIdx)){
                    return 1 * a.sortdir
                }
            } else {
                if (a.sortIdx < b.sortIdx) {
                    return -1 * a.sortdir
                }
                if (a.sortIdx > b.sortIdx) {
                    return 1 * a.sortdir
                }
            }
            return 0;
        });
        //assing sorted rows to getRows
        this._getRows = [];
        for (let i: number = 0; i < ret.length; i++) {
            this._getRows.push(ret[i].irow);
        }
    }
    sortIdx(a, b) {
        return (a - b)
    };
    calc_cols() {
        this.getCols = new Array<DOData>();
        for (let docDataRowID of this.getRows) {
            for (let template of this.lstChildDocDefTemplate) {
                let d: DOData = new DOData();
                let data: Array<NJDocData> = this.lstDocData.filter((d: NJDocData) => {
                    return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == template.docDefTemplateID && template.docDefTemplateID)
                })
                if (data.length == 1)
                    d.njDocData = data[0];
                else {
                    d.njDocData.docDefDataRowID = docDataRowID;
                    d.njDocData.docDefTemplateID = template.docDefTemplateID;
                    d.njDocData.dataValue = '';
                    d.njDocData.docDataHdrId = 0;
                }
                d.njDocDefTemplate = template;
                d.customParameters = template.dictCustomParameters
                this.getCols.push(d);

            }
        }
    }
    calc_colsAll() {
        this.getColsAll = new Array<DOData>();
        for (let docDataRowID of this.getRows) {
            for (let template of this.inChildDocDefTemplate) {
                let d: DOData = new DOData();
                let data: Array<NJDocData> = this.lstDocData.filter((d: NJDocData) => {
                    return (d.docDefDataRowID == docDataRowID && d.docDefTemplateID == template.docDefTemplateID && template.docDefTemplateID)
                })
                if (data.length == 1)
                    d.njDocData = data[0];
                else {
                    d.njDocData.docDefDataRowID = docDataRowID;
                    d.njDocData.docDefTemplateID = template.docDefTemplateID;
                    d.njDocData.dataValue = '';
                    d.njDocData.docDataHdrId = 0;
                }
                d.njDocDefTemplate = template;
                d.customParameters = template.dictCustomParameters;
                this.getColsAll.push(d);

            }
        }
        this.cdr.detectChanges();
    }
    public editCurItem(event: DOData) {
        if (this.isEnabled) {
            if (this.buttonClickPending == 0) {
                // IF this is a popup do not allow the row to be edited. Allow edit will be set for popups.
                if (this.allowDoubleClick) {
                    this.selectedRow = event.njDocData.docDefDataRowID;
                    this.editItem.emit(this.getGridVM_byRowAll(event.njDocData.docDefDataRowID));
                }

            } else { this.buttonClickPending--; }
        }
    }
    SetClass(): string {
        if (this.customParameters['Class'] == null) {
            return "table table-bordered";
        } else {
            return this.customParameters['Class'];
        }
    }
    findHeaderClass(template: NJDocDefTemplate): string {
        if (template.dictCustomParameters['HeaderClass'] == null) {
            return "table-bordered";
        } else {
            return template.dictCustomParameters['HeaderClass'];
        }
    }
    findHeaderStyles(template: NJDocDefTemplate) {
        if (template.dictCustomParameters['HeaderStyle'] == null) {
            return { "background-color": "lightgray", "padding": "3px", "text-align": "center", "border": "1px solid black", "border-color": "black", "border-top-color": "black" };
        } else {
            let styles = this.data.replaceAll(template.dictCustomParameters['HeaderStyle'], "'", '"');
            return JSON.parse(styles);
        }
    }
    public addItem(items: Array<NJDocData>) {
        this.lstDocData = [];
        for (let item of items) {
            this.lstDocData.push(item);
        }
        this.calc_rows();
    }
    onclickBut(event: DOData) {
        if (this.isEnabled) {
            this.buttonClickPending++;
            this.clickBut.emit(event);
        }
    }
    onTabEvent(event: componentVM) {
        this.tabEvent.emit(event);
    }
    onclickLink(message: DOData) {
        this.clickLink.emit(message);
    }
}
